import { render, staticRenderFns } from "./SaqSubmitted.vue?vue&type=template&id=41511617"
import script from "./SaqSubmitted.vue?vue&type=script&lang=js"
export * from "./SaqSubmitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports